<template>
    <div class="no-data w-100 d-flex flex-column justify-content-center align-items-center my-5">
        <i class="no-data__icon fad fa-empty-set mb-5 text-secondary"></i>
        <p class="no-data__text text-center font-weight-bold">{{message}}</p>
    </div>

</template>

<script>
export default {
    name: 'NoData',
    props: {
        message:{
            type: String,
            default: 'Keine Daten vorhanden.'
        }
    }
};
</script>
